/**
 * @ngdoc services
 * @memberof mercury.modules.time
 * @name TimeStaff
 */
angular.module('mercury.modules.time.staff')
.factory('TimeStaff', ["$resource", "$window", "settings", function($resource, $window, settings) {
  var Members = $resource(settings.mercHost + '/staff-members/:id', {id: '@id'}, {patch: {method: 'PATCH'}});
  var MembersExport = $resource(settings.mercHost + '/staff-members/export', {id: '@id'}, {patch: {method: 'PATCH'}});
  var MemberRemuneration = $resource(settings.mercHost + '/staff-member-remuneration-history/:id', {id: '@id'});

  /**
   * [getAll description]
   *
   * @memberof TimeStaff
   * @return {?} [description]
   */
  function getAll() {
    return Members.query().$promise;
  }

  /**
   * List all the active staff at a given point in time.
   *
   * @memberof TimeStaff
   * @param  {String} time ISO formatted date string. If not set, defaults to now.
   * @return {Object} Service promise
   */
  function getAllActive(time) {
    if (!time) {
      time = moment().format();
    }
    return Members.query({time: time}).$promise;
  }

  /**
   * [get description]
   *
   * @memberof TimeStaff
   * @param  {?} id [description]
   * @return {?}    [description]
   */
  function get(id) {
    return Members.get({id: id}).$promise;
  }

  /**
   * [create description]
   *
   * @memberof TimeStaff
   * @param  {?} staff [description]
   * @return {?}       [description]
   */
  function create(staff) {
    return Members.save(staff).$promise;
  }

  /**
   * [update description]
   *
   * @memberof TimeStaff
   * @param  {?} staff [description]
   * @return {?}       [description]
   */
  function update(staff) {
    return Members.update(staff).$promise;
  }

  /**
   * [remove description]
   *
   * @memberof TimeStaff
   * @param  {?} staff [description]
   * @return {?}       [description]
   */
  function remove(staff) {
    staff = angular.copy(staff);
    staff.datestampDeleted = moment.utc().format();
    return update(staff);
  }

  /**
   * [restore description]
   *
   * @memberof TimeStaff
   * @param  {?} staff [description]
   * @return {?}       [description]
   */
  function restore(staff) {
    staff = angular.copy(staff);
    staff.datestampDeleted = null;
    return update(staff);
  }

  /**
   * [updateRemuneration description]
   *
   * @memberof TimeStaff
   * @param  {?} history [description]
   * @return {?}         [description]
   */
  function updateRemuneration(history) {
    return MemberRemuneration.update(history).$promise;
  }

  /**
   * [deleteRemuneration description]
   *
   * @memberof TimeStaff
   * @param  {?} history [description]
   * @return {?}         [description]
   */
  function deleteRemuneration(history) {
    return MemberRemuneration.delete(history).$promise;
  }

  /**
   * [updatePaycode description]
   *
   * @memberof TimeStaff
   * @param  {?} id      [description]
   * @param  {?} payCode [description]
   * @return {?}         [description]
   */
  function updatePaycode(id, payCode) {
    var delta = [{op: 'replace', path: 'PayCode', value: payCode}];

    return Members.patch({id: id}, delta).$promise;
  }

  /**
   * [exportStaff description]
   *
   * @memberof TimeStaff
   * @param  {?} ids [description]
   * @return {?}     [description]
   */
  function exportStaff(ids) {
    var promise = MembersExport.save({format: 'AcePayroll'}, ids).$promise;

    promise.then(function(result) {
      $window.location.assign(result.location);
    });

    return promise;
  }

  return {
    getAll: getAll,
    getAllActive: getAllActive,
    get: get,
    create: create,
    update: update,
    remove: remove,
    restore: restore,
    updateRemuneration: updateRemuneration,
    deleteRemuneration: deleteRemuneration,
    updatePaycode: updatePaycode,
    exportStaff: exportStaff
  };
}]);
